<div class="modal-header">
  <h4 class="modal-title cs-modal-title">VIDEO AND AUDIO SETTINGS</h4>
  <button type="button" class="close" aria-label="Close" (click)="dialog.dismiss('Cross click')">
    <span aria-hidden="true">&times;</span>
  </button>
</div>
<div class="modal-body">
  <div class="text-center" *ngIf="!isStreamsLoadRequestFinished">
    <div class="spinner-border text-primary" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
  <div class="video-mic-settings" [hidden]="!isStreamsLoadRequestFinished">
    <div class="form-group">
      <label>Cameras:</label>
        <div class="opts-group mb-3" [hidden]="!isCameraAccessProvided">
          <!--        ng-repeat="device in dc.videoDevicesMetadata track by $index"-->
          <div class="d-flex align-items-center flex-wrap"
            *ngFor="let device of videoDevicesMetadata; let i = index"
            [ngClass]="{'disabled': !device.active}">
            <div class="custom-control custom-radio">
              <input type="radio" id="camera_device_{{i}}"
                class="custom-control-input"
                name="camera"
                (change)="onSelectCameraDevice($event, i)"
                [(ngModel)]="cameraDevice"
                value="{{device.id}}">
              <label for="camera_device_{{i}}" class="custom-control-label">{{device.label}}</label>
            </div>
            <span *ngIf="!device.active" class="badge cs-badge badge-light ml-2">in use</span>
          </div>
        </div>

      <div class="alert cs-alert alert-warning" *ngIf="!isCameraAccessProvided && isStreamsLoadRequestFinished">It seems you either do not have any cameras
        connected or you have not allowed this application to use your cameras.
      </div>
      <div class="text-center video-wrapp">
        <div #videoMediaWrapper id="local-video-preview-container" [hidden]="!isCameraAccessProvided" style="width: 200px"></div>
      </div>
    </div>

    <div class="form-group">
      <label>Microphones:</label>
      <div class="opts-group" [hidden]="!isMicrophoneAccessProvided">
        <!--        ng-repeat="device in dc.audioDevicesMethadata track by $index"-->
        <div class="d-flex align-items-center flex-wrap"
          *ngFor="let device of audioDevicesMetadata; let i = index"
          [ngClass]="{'disabled': !device.active}">
          <div class="custom-control custom-radio">
            <input type="radio" id="microphone_device_{{i}}" name="microphone_device"
              class="custom-control-input"
              (change)="onSelectMicrophoneDevice(i)"
              [(ngModel)]="microphoneDevice"
              [value]="device.id"
            >
            <label for="microphone_device_{{i}}" class="custom-control-label">{{device.label}}</label>
          </div>
          <span *ngIf="!device.active" class="badge cs-badge badge-light ml-2">in use</span>
        </div>
      </div>
    </div>
    <div class="alert alert-warning" *ngIf="!isMicrophoneAccessProvided && isStreamsLoadRequestFinished">It seems you either do not have any
      microphones connected or you have not allowed this application to use your microphones.
    </div>
    <div class="meter-wrapp" [hidden]="!isMicrophoneAccessProvided">
      <meter class="w-100"
        *ngIf="currentSelectedDeviceInfo.audio.id !== -1"
        value="{{currentSelectedDeviceInfo.audio.level}}"></meter>
    </div>

    <div class="form-group">
      <label>Speakers:</label>
      <div class="opts-group" [hidden]="!isSpeakerAccessProvided">
        <div class="d-flex align-items-center flex-wrap"
             *ngFor="let device of speakerDevicesMetadata; let i = index"
             [ngClass]="{'disabled': !device.active}">
          <div class="custom-control custom-radio">
            <input type="radio" id="speaker_device_{{i}}" name="speaker_device"
                   class="custom-control-input"
                   (change)="onSelectSpeakerDevice(i)"
                   [(ngModel)]="speakerDevice"
                   [value]="device.id"
            >
            <label for="speaker_device_{{i}}" class="custom-control-label">{{device.label}}</label>
          </div>
          <span *ngIf="!device.active" class="badge cs-badge badge-light ml-2">in use</span>
        </div>
      </div>

      <div class="alert cs-alert alert-warning" *ngIf="!isSpeakerAccessProvided && isStreamsLoadRequestFinished">It seems you either do not have any speakers
        connected or you have not allowed this application to use your speakers.
      </div>
    </div>
  </div>
</div>


<div class="modal-footer d-flex">
  <button (click)="onCancel()"
          type="button" class="btn btn-secondary"
          [ngClass]="{'disabled': disableButtons}">Cancel</button>
  <button (click)="onSubmit()"
          type="submit" class="btn btn-primary ml-auto"
          [ngClass]="{'disabled': disableButtons}">Save</button>
</div>










<!--<input type="radio" id="camera_device_15"-->
<!--  class="custom-control-input"-->
<!--  name="camera"-->
<!--  formControlName="camera"-->
<!--  (change)="aaaa()"-->
<!--  [(ngModel)]="aaa"-->
<!--  value="15">-->
<!--<label for="camera_device_15" class="custom-control-label">{{15}}</label>-->



<!--<input type="radio" id="camera_device_16"-->
<!--  class="custom-control-input"-->
<!--  name="camera"-->
<!--  formControlName="camera"-->
<!--  (change)="aaaa()"-->
<!--  [(ngModel)]="aaa"-->
<!--  value="16">-->
<!--<label for="camera_device_16" class="custom-control-label">{{16}}</label>-->




